export const formatNumber = (value: number, locale: string, suffix: string) => {
  const formattedNumber = new Intl.NumberFormat(locale).format(value);

  return `${formattedNumber} ${suffix}`;
};
